<template>
  <b-modal
    :id="`enter-auth-invalid${id}`"
    modal-class="modal-style"
    ref="modal"
  >
    <template>
      <p class="modal-style-title alert-title">提示</p>
      <div class="modal-style-content">
        <p>帳號密碼輸入錯誤</p>
      </div>
    </template>

    <template v-slot:modal-footer>
      <button
        class="custom-btn modal-style-single-btn"
        @click="$bvModal.hide(`enter-auth-invalid${id}`)"
      >
        確定
      </button>
    </template>
  </b-modal>
</template>

<script>
export default {
  props: {
    id: {
      required: true,
      type: Number
    }
  }
};
</script>
